import React from 'react';
import {
  Layout,
  TrustedByContractors,
  ReadyToSeePossibilities,
  NewsLetterBar,
} from '../../../v2/components/common';
import {
  ExteriorContractorsHero,
  ExteriorContractorsHeaderDescription,
  ExteriorContractorsMarketingAndSales,
  ExteriorContractorsProduction,
  ExteriorContractorsCaseStudies,
  ExteriorContractorsFitIntoYourBusiness,
} from '../../../v2/components/exterior-contractors';

const ExteriorContractors: React.FC = () => (
  <Layout
    title="Retail Contractors | Exterior Home Improvement"
    description="HOVER transforms smartphone photos into accurate measurements for any property. Learn how HOVER can drive efficiencies for your home improvement business."
    buttonType="CHAT_WITH_A_REP"
  >
    <ExteriorContractorsHero />
    <ExteriorContractorsHeaderDescription />
    <ExteriorContractorsMarketingAndSales />
    <ExteriorContractorsProduction />
    <ExteriorContractorsCaseStudies />
    <ExteriorContractorsFitIntoYourBusiness />
    <ReadyToSeePossibilities body="Whether you’re a small business, a national team, or somewhere in between, we can help." />
    <TrustedByContractors />
    <NewsLetterBar showForm showViewJobs={false} />
  </Layout>
);

export default ExteriorContractors;
